import { useTranslation } from '$shared/utils';
import { useMemo } from 'react';
import { StockStatus } from '../stock-status';

export function useDeliveryEstimate(stockStatus: StockStatus) {
    const { translate } = useTranslation();
    return useMemo(() => translate(`delivery.delivery-message-${stockStatus}`), [stockStatus]);
}
